import { aludraApi } from 'api/axios'
import { mdl12Urls } from './mdl12.urls'

export const uploadFile = async payload => {
  return aludraApi.post(mdl12Urls.uploadFileURL, payload)
}
